import React, { useState } from "react";
import "../Pricing.css";

function PricingBox1() {
    const [annual, setAnnual] = useState(false);

    const plans = [
        {
            name: "Starter",
            cards: 1,
            monthly: 25,
            yearly: 250,
            text: "Ideal for small businesses with one location.",
            features: [
                "1 card design",
                "1 location",
                "3 subusers",
            ],
        },
        {
            name: "Growth",
            cards: 3,
            monthly: 69,
            yearly: 690,
            text: "Designed for expanding businesses with multiple sites.",
            features: [
                "3 card design",
                "2 location",
                "5 subusers",
                "Card customizations",
            ],
        },
        {
            name: "Ultimate",
            cards: 5,
            monthly: 95,
            yearly: 950,
            text: "Best for larger businesses with advanced needs.",
            features: [
                "5 card design",
                "3 location",
                "8 subusers",
                "Card customizations",
                "Unique customer enrollments",
                "Data export",
            ],
        },
    ];

    return (
        <div className="pricing-section">
            <div className="container">

                <div className='home-box4-top' id='pricing-header'>
                    <h2>Simple, Flexible Pricing</h2>

                    <p>
                        <span>Billed monthly</span>

                        <label className="switch">
                            <input
                                type="checkbox"
                                onChange={() => setAnnual(!annual)}
                            />
                            <span className="slider"></span>
                        </label>

                        <span>Billed annually</span>
                    </p>
                </div>

                {/* Cards */}
                <div className="pricing-cards">

                    {plans.map((plan, index) => (
                        <div className="card" key={index}>

                            <h3>{plan.name}</h3>

                            <p className="card-count">{plan.cards} {plan.cards === 1 ? "Card" : "Cards"}</p>

                            <h1>
                                ${annual ? plan.yearly : plan.monthly}
                                <span>{annual ? "/ yr" : "/ mo"}</span>
                            </h1>

                            <p>{plan.text}</p>

                            <a href="/">Start 15-day Trial</a>

                            {/* Feature comparison list */}
                            <ul>
                                {plan.features.map((feature, i) => (
                                    <li key={i}>
                                        ✓ {feature}
                                    </li>
                                ))}
                            </ul>

                        </div>
                    ))}

                </div>

            </div>
        </div>
    );
}

export default PricingBox1;